;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('notificationItem', notificationItem)

  /* @ngInject */
  function notificationItem ($translate, $sce, $rootScope, $timeout, $location, $window, NotificationsCentralService, NotificationsService) {
    return {
      restrict: 'EA',
      scope: {
        notification: '<'
      },
      templateUrl: '/core/directives/notification-item/notification-item-directive.html?$$REVISION$$',
      link: function ($scope) {
        $scope.notification = _treatNotification($scope.notification)

        $scope.handleClickOnNotification = (event, notification) => {
          if (notification.customerCompany.id !== $rootScope.oUserCompany.id) {
            localStorage.setItem('notification', JSON.stringify(notification))

            const queryParams = $location.search()
            queryParams.company = notification.customerCompany.id

            $location.search(queryParams)
            $timeout(() => $window.location.reload(), false)
          } else {
            NotificationsService.readNotification(notification.id).then(reloadNotifications => {
              event.currentTarget.classList.add('read')
              $rootScope.$broadcast('reloadUnreadNotifications')
            })

            NotificationsCentralService.close()
            NotificationsCentralService.handleNotification(notification)
          }
        }

        function _treatNotification (notification) {
          notification.text = $sce.trustAsHtml($translate.instant(`notifications-central.${notification.type}.text`, {
            asset: notification.asset ? notification.asset.name : $translate.instant(`notifications-central.${notification.type}.defaults.asset`),
            user: notification.triggerUser ? notification.triggerUser.name : $translate.instant(`notifications-central.${notification.type}.defaults.user`),
            post: notification.post ? notification.post.title : $translate.instant(`notifications-central.${notification.type}.defaults.post`),
            task: notification.task ? notification.task.title || notification.task.name : $translate.instant(`notifications-central.${notification.type}.defaults.task`),
            art: notification.art ? notification.art.title || notification.art.name : $translate.instant(`notifications-central.${notification.type}.defaults.art`),
            auditScore: notification.audit ? notification.audit.score : $translate.instant(`notifications-central.${notification.type}.defaults.auditScore`),
            companyName: notification.contentId ? $rootScope.oUserCompany.formattedName : '',
            campaign: notification.campaign ? notification.campaign.title : ''
          }))

          notification.when = moment(notification.createdAt).fromNow()

          notification.icon = $translate.instant(`notifications-central.${notification.type}.icon`)
          return notification
        }
      }
    }
  }
})()
